/**
 * Create a simple get handler for a `path()` that will always return the supplied value
 * @param {*} constantValue - the value the get handler should return
 * @returns {Object} - the route definition containing the handler
 * @example
 * muster()
 *   .path('data.maxValue', constant(1000));
 *   .path('data.minValue', constant(22));
 */
function constant(constantValue) {
  if (constantValue === undefined) {
    throw new Error(`Must supply a value to constant(), supplied ${constantValue}`);
  }
  return {
    get: ({ res }) => res.value(constantValue),
  };
}

module.exports = constant;
